import styled from 'styled-components';

export const List = styled.div`
	max-height: 270px;
	overflow-y: auto;
	margin: 8px 0;
`;

export const VersionRow = styled.div<{ $selected?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 12px;
	border-radius: 4px;
	background: ${({ theme, $selected }) => ($selected ? theme.blue[300] : 'transparent')};

	&:hover {
		background: ${({ theme, $selected }) => ($selected ? theme.blue[300] : theme.gray[100])};
	}
`;

export const VersionLabel = styled.span`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const RowRight = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const DuplicateLink = styled.span`
	font-size: 12px;
	color: ${({ theme }) => theme.blue[600]};
	opacity: 0;
	transition: opacity 0.15s;

	${VersionRow}:hover & {
		opacity: 1;
	}

	&:hover {
		color: ${({ theme }) => theme.blue[800]};
	}
`;

export const VersionDate = styled.span`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
`;
